import { RequireCapability } from '../../auth/RequireAuth';
import type { FeatureRoute } from '../types';
import { SupportInboxPage } from './SupportInboxPage';

const page = (
  <RequireCapability anyOf={['support.chat']} what="the support inbox">
    <SupportInboxPage />
  </RequireCapability>
);

export const routes: FeatureRoute[] = [
  { path: 'inbox', element: page },
  { path: 'inbox/:id', element: page },
];
